// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2MXba","addWidgetButton":"Header_addWidgetButton__2tYtR","dashboardTabs":"Header_dashboardTabs__2QOvI","active":"Header_active__kUx0W"};